/**
 * @owner @Appboy/messaging-experience
 */
import { canvasStepRemoteLookupValidators } from "../.generated/canvasStepRemoteLookup";
import type { CanvasStepRemoteLookupProvider } from "../.generated/canvasStepRemoteLookup";

export const canvasStepProvider: CanvasStepRemoteLookupProvider = {
  // Identity is the composite (canvas_id, step_id) so a step is always resolved
  // within its parent Canvas.
  mapItemToId: (item) => ({ canvas_id: item.canvas_id, step_id: item.step_id }),
  mapIdToString: (id) => `${id.canvas_id}::${id.step_id}`,
  // The backend searches steps on name; match on name only.
  mapItemToSearchString: (item) => item.name ?? "",
  validators: canvasStepRemoteLookupValidators,
};
